import React from 'react';
import { useSearchParams } from 'react-router-dom';
import '../styles/ConfiguratorApp.css';

/**
 * ConfiguratorApp - Affiche le configurateur dans une iframe
 * Adapté pour le site bt-regulation.fr
 */
function ConfiguratorApp() {
  const [searchParams] = useSearchParams();
  const system = searchParams.get('system') || 'chauffage';

  const configuratorFiles = {
    chauffage: `${process.env.PUBLIC_URL}/configurator/agile4-v1/Agile4.html`,
    vapeur: `${process.env.PUBLIC_URL}/configurator/Agile5-v1/agile5.html`
  };

  // Rediriger directement vers le fichier HTML
  React.useEffect(() => {
    window.location.href = configuratorFiles[system];
  }, [system]);

  return (
    <div className="bt-configurator-app">
      <p>Chargement du configurateur...</p>
    </div>
  );
}

export default ConfiguratorApp;
